import React from 'react'
import Link from '../Link'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'

const ChildNav = ({
  url,
  label,
  subtitle,
  image,
  newProductLink,
  ctaText,
  locale,
}) => {
  return (
    <Link
      className={
        !subtitle && !ctaText && !image && !newProductLink
          ? styles.childShrink
          : ''
      }
      to={(url += url.endsWith('/') ? '' : '/')}
    >
      <div className={styles.container}>
        {image && (
          <div className={styles.imageBox}>
            {image.gatsbyImageData ? (
              <GatsbyImage
                image={image.gatsbyImageData}
                style={{ width: '100%', height: '100%' }}
                alt={label || image.description}
              />
            ) : (
              <img
                src={image.file.url}
                style={{ width: '100%', height: '100%' }}
                alt={label || image.description}
              />
            )}
          </div>
        )}

        <div
          className={[
            styles.descriptionBlock,
            image ? styles.hasImage : '',
            locale.indexOf('zh') !== -1 ? styles.isChinese : '',
          ].join(' ')}
        >
          <div>
            {label && (
              <div
                className={`${styles.label} ${
                  newProductLink && styles.labelNew
                }`}
              >
                {label}
              </div>
            )}
          </div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          {ctaText && (
            <div className={styles.ctaTextLink}>
              {ctaText}
              &nbsp;&nbsp;
              <svg
                width="7"
                height="12"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.667 6L0 1.2 1.167 0 7 6l-5.833 6L0 10.8 4.667 6z"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </Link>
  )
}

export default ChildNav
